import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-appmenu',
  templateUrl: './appmenu.component.html',
  styleUrls: ['./appmenu.component.css']
})
export class AppmenuComponent implements OnInit {
  userType;
  superadmin_user;
  constructor(private router: Router) { }

  ngOnInit() {
    this.userType = localStorage.getItem('userType');
    if (this.userType === 'superadmin') {
      this.superadmin_user = true;
    }
    // console.log(this.userType);
    // $(document).ready(() => {
    //   const trees: any = $('[data-widget="tree"]');
    //   trees.tree();
    // });
  }

}
